import { Modal } from '@frontend/design-system';
import { usePaymentMethodSetupContext } from '../../../widgets/payment-method-setup/context/payment-method-setup-base.context';
import { CardOnFileActions } from '../../card-on-file/actions/actions';

/** Inline, right-aligned Cancel / Save, like the Weave app's add-card modal. */
export const PaymentMethodSetupFooter = () => {
  const {
    primary: { label: primaryLabel, ...primary },
    secondary: { label: secondaryLabel, ...secondary },
  } = usePaymentMethodSetupContext();

  return (
    <Modal.Footer>
      <CardOnFileActions
        shouldShow
        shouldUsePadding={false}
        primary={{ ...primary, children: primaryLabel }}
        secondary={{ ...secondary, children: secondaryLabel }}
      />
    </Modal.Footer>
  );
};
